import { $, addAction, INIT } from '@situation/setdesign.util';

addAction(INIT, () => {
    $('.heading--splatter').wrapInner('<span class="heading__inner">');
    $('.text--bg-diamond').each(() => {
        const $el = $(this);
        const content = ($el.html() || '')
            .split(' ')
            .map((word) => `<span class="text--bg-diamond">${word}</span>`)
            .join(' ');
        $el.html(content).removeAttr('class');
    });
});
